module.exports = __webpack_public_path__ + "static/media/texture (4).4dd95c1d.jpg";